import React, { Component } from "react";
import PropTypes from "prop-types";
import "./featuredVideoCard.scss";

class VideoCard extends Component {
  render() {
    const { video } = this.props;

    return (
      <div className="col-lg-4 col-md-6 col-sm-12 pb-40 learn-featured-video-card">
        <a href={video.url} target="_blank" rel="noopener noreferrer">
          <div className="media">
            <div className="col-12 no-gutter">
              <img
                src={video.image}
                role="presentation"
                alt=""
                className="img-responsive"
              />
            </div>
            <div className="col-12 media-body">
              <h3 className="media-heading small">{video.title}</h3>
              <p>{video.description}</p>
            </div>
          </div>
        </a>
      </div>
    );
  }
}

VideoCard.propTypes = {
  video: PropTypes.shape({
    url: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string
  })
};
VideoCard.defaultProps = {
  video: {
    url: "",
    image: "",
    title: "",
    description: ""
  }
};

export default VideoCard;
